import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import { Button, Modal } from 'toonswap-uikit'
import ModalActions from 'components/ModalActions'
import { useTranslation } from 'contexts/Localization'
import TokenInput from '../../../components/TokenInput'
import { getFullDisplayBalance } from '../../../utils/formatBalance'
import styled from 'styled-components'

interface DepositModalProps {
  max: BigNumber
  onConfirm: (amount: string, decimals: number) => void
  onDismiss?: () => void
  tokenName?: string
  stakingTokenDecimals?: number
}

const ActionButton = styled(Button)`
  background-color: #fe7b2a !important;
  color: #ffffff;
  border: 2px solid #2b3335;
  border-radius: 12px;
  font-weight: 600;
  &:hover:not(:disabled) {
    opacity: 0.9;
    background: #fe7b2a !important;
  }
  &:disabled {
    background: #747f81 !important;
  }
`

const DepositModal: React.FC<DepositModalProps> = ({
  max,
  onConfirm,
  onDismiss,
  tokenName = '',
  stakingTokenDecimals = 18,
}) => {
  const [val, setVal] = useState('')
  const [pendingTx, setPendingTx] = useState(false)
  const { t } = useTranslation()
  const fullBalance = useMemo(() => {
    return getFullDisplayBalance(max, stakingTokenDecimals)
  }, [max, stakingTokenDecimals])

  const handleChange = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      setVal(e.currentTarget.value)
    },
    [setVal],
  )

  const handleSelectMax = useCallback(() => {
    setVal(fullBalance)
  }, [fullBalance, setVal])

  return (
    <Modal title={`${t('Deposit')} ${tokenName} Tokens`} onDismiss={onDismiss}>
      <TokenInput
        value={val}
        onSelectMax={handleSelectMax}
        onChange={handleChange}
        max={fullBalance}
        symbol={tokenName}
      />
      <ModalActions>
        <ActionButton width="100%" variant="secondary" onClick={onDismiss}>
          {t('Cancel')}
        </ActionButton>
        <ActionButton
          width="100%"
          disabled={pendingTx || !val || val === '0' || Number(fullBalance) < Number(val)}
          onClick={async () => {
            setPendingTx(true)
            await onConfirm(val, stakingTokenDecimals)
            setPendingTx(false)
            onDismiss()
          }}
          variant="primary"
        >
          {pendingTx ? t('Pending Confirmation') : t('Confirm')}
        </ActionButton>
      </ModalActions>
    </Modal>
  )
}

export default DepositModal
